import Formation from '../types/api/Formation';
import { 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    TextField, 
    Grid2, 
    Stack,
    Checkbox,
    FormControlLabel
} from '@mui/material';

interface FormationFormProps {
    open: boolean,
    close: ()=>void,
    save: (employee: Formation)=>void,
    baseFormation: Formation,
    updateFormation: (formation: Formation)=>void,
    confirmLabel: string
}
export function FormationForm(FormationFormProps: FormationFormProps) {
    return (
        <Dialog 
            slotProps={{ paper: { elevation: 0, sx: { borderRadius: 2 } } }} 
            sx={{ p: { xs: 2, md: 3 } }} 
            open={FormationFormProps.open} 
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle>Gestion des formations</DialogTitle>
            
            <DialogContent>
                <Stack spacing={3} sx={{ pt: 1 }}>
                    <TextField
                        label="Nom de la formation"
                        value={FormationFormProps.baseFormation.label || ''}
                        onChange={(e) => FormationFormProps.updateFormation({
                            ...FormationFormProps.baseFormation,
                            label: e.target.value
                        })}
                        fullWidth
                        required
                    />
                    
                    <Grid2 container spacing={2}>
                        <Grid2 size={10}>
                            <TextField
                                label="Ratio"
                                type="number"
                                value={FormationFormProps.baseFormation.ratio || 0}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    ratio: parseFloat(e.target.value) || 0
                                })}
                                fullWidth
                            />
                        </Grid2>
                        
                        <Grid2 size={2}>
                            <TextField
                                label="Couleur"
                                type="color"
                                value={FormationFormProps.baseFormation.color || '#000000'}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    color: e.target.value
                                })}
                                fullWidth
                            />
                        </Grid2>
                    </Grid2>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={FormationFormProps.baseFormation.autoStaffing || false}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    autoStaffing: e.target.checked
                                })}
                            />
                        }
                        label="Auto Staffing"
                    />

                    <Grid2 container spacing={2}>
                        <Grid2 size={4}>
                            <TextField
                                label="Bottom Cap"
                                type="number"
                                value={FormationFormProps.baseFormation.bottomCap || ''}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    bottomCap: e.target.value ? parseFloat(e.target.value) : undefined
                                })}
                                fullWidth
                            />
                        </Grid2>
                        
                        <Grid2 size={4}>
                            <TextField
                                label="Minimum Shifts"
                                type="number"
                                value={FormationFormProps.baseFormation.minimumShifts || null}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    minimumShifts: e.target.value ? parseFloat(e.target.value) : undefined
                                })}
                                fullWidth
                            />
                        </Grid2>
                        
                        <Grid2 size={4}>
                            <TextField
                                label="Maximum Shifts"
                                type="number"
                                value={FormationFormProps.baseFormation.maximumShifts || null}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    maximumShifts: e.target.value ? parseFloat(e.target.value) : undefined
                                })}
                                fullWidth
                            />
                        </Grid2>
                    </Grid2>

                    <Grid2 container spacing={2}>
                        <Grid2 size={6}>
                            <TextField
                                label="Grouping ID"
                                type="number"
                                value={FormationFormProps.baseFormation.groupingId || ''}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    groupingId: e.target.value ? parseFloat(e.target.value) : undefined
                                })}
                                fullWidth
                            />
                        </Grid2>
                        
                        <Grid2 size={6}>
                            <TextField
                                label="Grouping Priority"
                                type="number"
                                value={FormationFormProps.baseFormation.groupingPriority || ''}
                                onChange={(e) => FormationFormProps.updateFormation({
                                    ...FormationFormProps.baseFormation,
                                    groupingPriority: e.target.value ? parseFloat(e.target.value) : undefined
                                })}
                                fullWidth
                            />
                        </Grid2>
                    </Grid2>
                </Stack>
            </DialogContent>
            
            <DialogActions>
                <Button onClick={FormationFormProps.close} color="error">
                    Annuler
                </Button>
                <Button 
                    onClick={() => FormationFormProps.save(FormationFormProps.baseFormation)} 
                    variant="contained" 
                    color="primary"
                >
                    {FormationFormProps.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FormationForm;